<!-- eslint-disable vue/require-v-for-key -->
<template>
  <article class="segment">
    <header class="segment__flightNumber">
      <span v-for="(detail, index) in segment.flight_detail" :key="index">
        {{ `${detail.carrier_code}${detail?.flight_number}` }}
        <i class="fas fa-caret-right segment__flightNumberCaret"></i>
      </span>
    </header>
    <div class="segment__body">
      <section class="segment__coreInformation">
        <header class="segment__head">
          <span class="segment__time">
            {{ segment.departure.time | timeFormat }}
          </span>
          <div class="segment__dateCode">
            <span class="segment__date">
              {{ segment.departure.date | flightFormat }}
            </span>
          </div>
        </header>
        <header class="segment__destination">
          <span class="segment__city">{{
            getAirportCityName(segment.departure.airport_reference_id)
          }}</span>
          <span class="segment__airport">{{
            segment.departure.airport_reference_id
          }}</span>
        </header>
      </section>

      <section class="segment__tripInformation">
        <header class="segment__lines">
          <div class="segment__dot"></div>
          <div class="segment__information">
            <div class="segment__timeInformation">
              <i class="fas fa-clock"></i>
              {{ segment.travel_time | minutesFormatPipe }}
            </div>
          </div>
          <div class="segment__arrow"></div>
        </header>
        <div class="segment__moreInformation">
          <span class="segment__connections"> {{ connectionsAndStops }} </span>
          <span
            v-if="!isMobile"
            class="segment__detail"
            @click.stop="$emit('openFlightDetail')"
          >
            {{ $t('shopping_lib.detail') }}
          </span>
        </div>
        <div v-if="isMobile" class="segment__moreInformation_detail">
          <span class="segment__detail" @click.stop="$emit('openFlightDetail')">
            {{ $t('shopping_lib.detail') }}
          </span>
        </div>
      </section>

      <section class="segment__coreInformation --arrival">
        <header class="segment__head">
          <span class="segment__time --arrival">
            <span>{{ segment.arrival.time | timeFormat }}</span>
            <!-- <span class="segment__timeIndicator">{{ dayIndicator }}</span> -->
          </span>
          <div class="segment__dateCode --arrival">
            <span class="segment__date">
              {{ segment.arrival.date | flightFormat }}
            </span>
          </div>
        </header>
        <header class="segment__destination --arrival">
          <span class="segment__city">{{
            getAirportCityName(segment.arrival.airport_reference_id)
          }}</span>
          <span class="segment__airport">{{
            segment.arrival.airport_reference_id
          }}</span>
        </header>
      </section>
    </div>
  </article>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Segment',
  props: {
    segment: {
      required: false,
    },
    checkedBaggage: {
      required: false,
      type: Object,
    },
    airportsInformation: {
      required: false,
      type: Object,
    },
  },
  inject: ['isMobile'],
  filters: {
    flightFormat(date) {
      return moment(date).format('DD MMM YYYY').replace('.', '')
    },
    dateFormat(date) {
      return moment(date).format('DD-MM-YYYY')
    },
    timeFormat: function (time) {
      return moment(time, 'HH:mm:ss').format('HH:mm')
    },
    minutesFormatPipe(minutesQuantity) {
      const duration = moment.duration(minutesQuantity, 'minutes')
      const days = duration.days() ? `${duration.days()}d` : ''
      const hours = duration.hours() ? `${duration.hours()}h` : ''
      const minutes = duration.minutes() ? `${duration.minutes()}m` : ''
      return `${days} ${hours} ${minutes}`
    },
  },
  computed: {
    connectionsAndStops: function () {
      if (this.segment.connections && this.segment.stops) {
        return `${this.segment.connections} ${this.$t('shopping_lib.connection')} ${this.segment.stops} ${this.$t('shopping_lib.stop')}`
      } else if (this.segment.connections) {
        return `${this.segment.connections} ${this.$t('shopping_lib.connection')}`
      } else if (this.segment.stops) {
        return `${this.segment.stops} ${this.$t('shopping_lib.stop')}`
      } else {
        return this.$t('shopping_lib.direct_flight')
      }
    },
  },
  methods: {
    getAirportCityName(id) {
      return this.airportsInformation[id].location_city_name
    },
  },
}
</script>

<style lang="sass" scoped>

$time-information-width: 6rem
$line-space: 2rem
$dot-width-height: .25rem
.segment
  transition: all .2s ease
  height: 100%
  &:first-child
    border-bottom: 1px  solid var(--color-overlay-10)
  &.--active
    box-shadow: inset 0 -.25rem 0 0 var(--color-primary)
  &.--off
    background-color: var(--color-background)
.segment__label
  display: flex
  font-weight: 600
  background-color: var(--color-overlay-05)
  font-size: var(--font-size-xs)
  padding: .25rem 1rem
  border-radius: 0 var(--b-radius-md) var(--b-radius-md) 0
  margin-right: .75rem
  text-align: right
.segment__flightNumber
  display: flex
  font-weight: 700
  font-size: var(--font-size-sm)
  font-style: normal
  line-height: 1.375rem
  padding: .125rem 0 0 .75rem
  width: 100%
  span:last-child i
    display: none
.segment__flightNumberCaret
  padding: 0 0.375rem 0 0.375rem
.segment__body
  padding: 0 1rem .5rem 1rem
  display: flex
.segment__coreInformation
  display: flex
  flex-direction: column
  &.--arrival
    align-items: flex-end
.segment__time
  font-size: var(--font-size-xl)
  font-weight: 400
  min-width: 5rem
  display: flex
  flex-direction: row
  align-items: baseline
.segment__timeInformation
  display: flex
  justify-content: center
  align-items: center
  gap: 5px
  min-width: $time-information-width
  height: 1.5rem
  padding: 1px 8px 1px 6px
  border: 1px solid rgba(33, 33, 33, 0.3)
  border-radius: .85rem
  font-weight: 700
  background: #FFFFFF
.segment__information
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  max-height: 3rem
.segment__connections
  font-weight: 700
  text-transform: uppercase
  color: var(--color-primary)
  font-size: var(--font-size-sm)
  max-width: 20ch
.segment__detail
  border-radius: 0.25rem
  background: rgba(0, 33, 87, 0.10)
  padding: 0 .5rem
  color: var(--color-primary)
  font-size: var(--font-size-sm)
  &:hover, &:focus
    box-shadow: inset 0 0 0 2em var(--color-primary)
    color: var(--color-onPrimary)
    cursor: pointer
.segment__dateCode
  font-size: var(--font-size-sm)
  text-transform: uppercase
  display: flex
  align-items: baseline
.segment__airport
  font-weight: 700
  font-size: var(--font-size-md)
.segment__tripInformation
  display: flex
  flex-direction: column
  justify-content: center
  max-height: 4.15rem
  width: 100%
.segment__lines
  display: flex
  flex-direction: row
  justify-content: center
  height: 100%
  width: 100%
  position: relative
.segment__moreInformation
  display: flex
  justify-content: space-evenly
  align-items: flex-end

.segment__destination
  display: flex
  flex-direction: column
  align-items: center
  text-align: center

.segment__city
  font-weight: 700
  font-size: var(--font-size-sm)
  text-transform: lowercase
  display: inline-block
  order: 2
  &:first-letter
    text-transform: uppercase

.segment__time
  &.--arrival
    justify-content: flex-end
.segment__dateCode
  &.--arrival
    justify-content: flex-end

@media (min-width: 768px)
  .segment
    border-right: 1px solid var(--color-overlay-10)
    display: flex
    flex-wrap: wrap

  .segment__coreInformation
    flex-direction: row-reverse
    align-items: flex-start
    width: 30%
    justify-content: space-between
    &:first-child
      flex-direction: row
    &.--arrival
      align-items: flex-start
  .segment__airport
    font-size: var(--font-size-xl)
    font-weight: 400
  .segment__tripInformation
    width: 40%
    max-height: 4.25rem
  .segment__body
    flex: 1
  .segment__connections, .segment__detail
    font-size: var(--font-size-sm)
  .segment__moreInformation
    justify-content: space-between
    padding: 0 2rem
  .segment__lines
    &:after,
    &:before
      background-color: var(--color-overlay-10)
      content: ''
      position: absolute
      top: calc(50% - calc(0.125rem/2))
      margin: auto
      width: calc(50% - calc(6rem/2) - 2rem)
      height: 2px
    &:before
      right: calc(0% + 2rem)
    &:after
      left: calc(0% + 2rem)
  .segment__dot::before
    content: ''
    background-color: var(--color-overlay-10)
    position: absolute
    transform: rotate(45deg)
    width: $dot-width-height
    height: $dot-width-height
    left: calc( 0% + 2rem - .25rem )
    top: calc(50% - calc(.25rem/2))
  .segment__arrow
    &:before, &:after
      content: ""
      position: absolute
      right: calc(0% + 2rem)
      top: 50%
    &:before
      border-color: var(--color-overlay-10)
      border-style: solid
      border-width: 0 0 2px 2px
      height: 6px
      margin-top: -3px
      width: 6px
      transform: rotate( -135deg )
      -webkit-transform: rotate( -135deg )

@media (min-width: 768px) and (max-width: 992px)
  .segment__moreInformation
    padding: 0

@media (max-width: 418px)
  .segment__body
    padding: 0.375rem 0.5rem 0.75rem 0.5rem
  .segment__detail, .segment__connections
    font-size: var(--font-size-sm)
  .segment__flightNumber
    padding: .125rem 0rem 0rem 0.75rem

@media (max-width: 768px)

  .segment__tripInformation
    max-height: 100%
    justify-content: space-between
  .segment__lines
    max-height: 3rem
  .segment__moreInformation
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
  .segment__destination
    align-items: start
    &.--arrival
      align-items: end
  .segment__city
    margin-top: 0.2rem
    order: 1
  .segment__airport
    order: 2

  .segment__moreInformation_detail
    display: flex
    justify-content: space-evenly
    margin-top: 1.65rem
    margin-bottom: 0.35rem


@media (min-width: 1200px)
  .segment__coreInformation
    width: 20%
  .segment__tripInformation
    width: 60%
</style>
